exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggestion[data-v-5d8391e4]:hover {\n  box-shadow: 0 0 2px [object Object];\n}\n.suggestion.selected[data-v-5d8391e4], .suggestion.selected *[data-v-5d8391e4], .suggestion[data-v-5d8391e4]:hover, .suggestion:hover *[data-v-5d8391e4] {\n  color: [object Object] !important;\n  border-color: [object Object] !important;\n}", ""]);

// exports
